import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import MakeInformedDecisionsPng2x from './assets/MakeInformedDecisions@2x.png'
import MakeInformedDecisionsWebp from './assets/MakeInformedDecisions.webp'
import MakeInformedDecisionsWebp2x from './assets/MakeInformedDecisions@2x.webp'

const MakeInformedDecisionsImage = () => {
  return (
    <Picture>
      <source type="image/webp" srcSet={`${MakeInformedDecisionsWebp}, ${MakeInformedDecisionsWebp2x} 2x`} />
      <Image
        src={MakeInformedDecisionsPng2x}
        alt="Illustration: Clean and compliant customer data"
        width="961"
        height="810"
        loading="lazy"
      />
    </Picture>
  )
}

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

export default MakeInformedDecisionsImage
